// ink-component
import React from 'react';
import styled from 'styled-components';

import { elevationTokens } from '../../../../tokens/globals/tokens';

import { StyledBody } from '../NewTableBody/NewTableBody';
import { StyledHead } from '../NewTableHead/NewTableHead';

export interface NewTableFootProps extends React.TableHTMLAttributes<HTMLTableSectionElement> {
  /** Sticky container bottom offset */
  offsetStickyBottom?: React.CSSProperties['bottom'];
}

const StyledFoot = styled.tfoot<NewTableFootProps>`
  z-index: ${elevationTokens.GlobalNewTableFooterInitial};
  position: sticky;
  bottom: ${({ offsetStickyBottom }) => offsetStickyBottom ?? 0};
  left: 0;

  ${StyledBody} &&,
  ${StyledHead} && {
    display: none;
  }
`;

/**
 * @group NewTable
 * @purpose Fixed footer at the bottom of NewTable
 * @categories table
 * @HTMLType HTMLTableSectionElement
 */
function NewTableFoot({ style, className, offsetStickyBottom, ...otherProps }: NewTableFootProps) {
  return <StyledFoot {...otherProps} offsetStickyBottom={offsetStickyBottom} />;
}

NewTableFoot.displayName = 'NewTable.Foot';

export default NewTableFoot;
